package link.erpango.quip.core.factory

import androidx.compose.runtime.Composable
import androidx.lifecycle.ViewModelStoreOwner
import androidx.lifecycle.viewmodel.compose.viewModel
import link.erpango.quip.core.interactor.NoteImportBulkCreator
import link.erpango.quip.domain.catalog.DefaultSparePartCatalog
import link.erpango.quip.domain.entities.DVehicle
import link.erpango.quip.domain.noteimport.NoteImportTarget
import link.erpango.quip.domain.usecases.INoteImportUseCase
import link.erpango.quip.features.noteimport.NoteImportBulkViewModel
import link.erpango.quip.features.noteimport.NoteImportViewModel

class NoteImportFactory(
    private val noteImportInteractor: INoteImportUseCase,
    private val bulkCreator: NoteImportBulkCreator,
    private val loadGarage: suspend () -> List<DVehicle>,
    private val viewModelStoreOwner: ViewModelStoreOwner
) : IFactory {

    /**
     * ViewModel del diálogo "Rellenar desde nota" de un formulario (una instancia por destino).
     * Vive toda la sesión: el diálogo llama a `open()`/`reset()` para empezar limpio.
     */
    @Composable
    fun createNoteImportViewModel(target: NoteImportTarget): NoteImportViewModel {
        return viewModel(viewModelStoreOwner, "note_import_${target.code}") {
            NoteImportViewModel(noteImportInteractor, DefaultSparePartCatalog)
        }
    }

    /**
     * ViewModel de la importación masiva desde el garaje. Una sola instancia: la pantalla y el
     * enlace "Importar todo" del diálogo comparten la misma, que sobrevive a la navegación.
     */
    @Composable
    fun createBulkViewModel(): NoteImportBulkViewModel {
        return viewModel(viewModelStoreOwner, "note_import_bulk") {
            NoteImportBulkViewModel(noteImportInteractor, bulkCreator, loadGarage)
        }
    }
}
